import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

const slide1HTML = `
    <Box>
        <Box style="margin-bottom: 10px; display: flex; align-items: flex-start;">
            <Box style="margin-right: 10px; margin-top: 2px;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="20"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
            </Box>
            <Box>
                <Box style="font-weight: 600;">Online Payments:</Box>
                <Box style="color: #222222; font-size: 16px;">Clients can pay using a card on file or through a payment link.</Box>
            </Box>
        </Box>

        <Box style="margin-bottom: 10px; display: flex; align-items: flex-start;">
            <Box style="margin-right: 10px; margin-top: 2px;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="20"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
            </Box>
            <Box>
                <Box style="font-weight: 600;">In-Person Payments:</Box>
                <Box style="color: #222222; font-size: 16px;">Accept contactless, swipe, or chip payments with an optional POS / card reader.</Box>
            </Box>
        </Box>
    </Box>
`;

const slide2HTML = (isMobile: boolean) => {
    const mobileHeadingFontSize = isMobile ? '18px' : '26px';

    return `
        <p style="font-size: 18px; margin-bottom: 30px;">
            Earn today, <span style="font-family: 'Segoe Script', 'Brush Script MT', cursive; font-style: italic; font-weight: 600; text-decoration: underline;">get your money</span> on the next business
            day — because waiting isn't always an option.
        </p>

        <h2 style="font-size: ${mobileHeadingFontSize}; margin-bottom: 10px; font-weight: 500;">Simple Pricing</h2>

        <span style="font-family: 'Segoe Script', 'Brush Script MT', cursive; font-style: italic; font-size: 20px; display: inline-block; transform: rotate(-8deg); position: relative; top: -5px; margin-right: 5px; margin-bottom: 0; text-decoration: underline;">Only</span><br/>
        <span style="background-color: #333; color: white; padding: 5px 12px; border-radius: 20px; font-weight: 500; display: inline-block; margin-right: 8px;">2.9% + $0.30</span>
        <span style="line-height: 2;">per transaction—no hidden fees or complicated math.</span>
  `;
};

const slide3HTML = (isMobile: boolean) => {
    const mobileFontSize = isMobile ? '16px' : '26px';

    return `
        We just need to verify your bank and ID details. Don’t worry—this information is kept private and won’t be shared with anyone.
        <p style="font-size: ${mobileFontSize}; font-weight: 500; margin-bottom: -17px !important;">Start taking payments.</p>
        <p style="font-size: 16px;">Once your verification is approved—typically instant, but it may take up to three business days—you’re ready to accept digital payments. If you wish, you can also order an optional POS device.</p>
    `;
};

export const getPaymentSlides = (
    primaryButtonLabel: string,
    disabled: boolean,
    isMobile: boolean,
    onAdd?: () => void,
    onLearnMore?: () => void
): Slide[] => [
    {
        id: 1,
        title: 'CuddlesPay makes payments easy.',
        description: slide1HTML,
        image: 'images/sliders/payment/slider-payment-1.jpg',
        /*videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add an agreement?',
        videoDuration: '0:28',
        videoUrl: 'https://www.loom.com/share/f70498401c0944d782e186126fe8d446',*/
        primaryButton: {
            text: 'Book CuddlesPay Setup',
            color: '#92B4A7',
            hoverColor: '#92B4A7',
            disabled: disabled,
            target: '_blank',
            href: 'https://meetings.hubspot.com/hunter251/cuddlespay-demo',
            colorVariant: 'green'
        },
        secondaryButton: {
            text: 'Learn more',
            onClick: onLearnMore
        }
    },
    {
        id: 2,
        title: 'Get paid fast with free, next-day payouts.',
        description: slide2HTML(isMobile),
        image: 'images/sliders/payment/slider-payment-2.jpg'
        /*videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add an agreement?',
        videoDuration: '0:28',
        videoUrl: 'https://www.loom.com/share/f70498401c0944d782e186126fe8d446',*/
    },
    {
        id: 3,
        title: 'Sign up for CuddlesPay',
        description: slide3HTML(isMobile),
        image: 'images/sliders/payment/slider-payment-3.jpg',
        /*videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'Why CuddlesPay?',
        videoDuration: '0:28',
        videoUrl: 'https://www.loom.com/share/f70498401c0944d782e186126fe8d446',*/
        primaryButton: {
            text: 'Get Started',
            color: '#92B4A7',
            hoverColor: '#92B4A7',
            colorVariant: 'green',
            onClick: onAdd
        },
        secondaryButton: {
            text: 'Learn more',
            onClick: onLearnMore
        }
    }
];
